import React, { Component } from "react";
import ImageOrInitial from "./ImageOrInitial";

class Selector extends Component {

  constructor(props) {
    super(props);
    this.state = {
      key:this.props.defaultValue,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.defaultValue && this.props.defaultValue && prevProps.defaultValue !== this.props.defaultValue) {
      this.setState({key:this.props.defaultValue})
    }
  }

  onChange = (event) =>{
    console.log(event.target.value);


    if(this.props.onChange){
      if(this.props.options[0]?.name){
        this.props.options.forEach(o => {
          if(o.name == event.target.value) this.props.onChange(o);
        });
      }
      else{
        this.props.onChange(event.target.value);
      }
    }
  }

  render() {
    var _defaultValue = null;;
    if(this.props.defaultValue){
      _defaultValue = this.props.defaultValue.name || this.props.defaultValue;
    }

    return (
      <div  className="fieldInputOutter">
      <select key={this.state.key} defaultValue={_defaultValue}  className="fieldInput" onChange={this.onChange}>
         {this.props.options.map((option, index) => {
          let _val = option.name || option.display || option;
          return <option key={_val} value={_val}>{_val}</option>
        })}
    </select>
    </div>
    );
  }
}
 
export default Selector;